import { useEffect } from 'react'
import { updatePageTitle } from '../../redux/active_page/actions'
import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'

const AboutPage = () => {

    const dispatch: Dispatch = useDispatch()
    useEffect(() => {
        dispatch(updatePageTitle("About Me"));
    }, [])

    return (
        <div>AboutPage</div>
    )
}

export default AboutPage